export default __webpack_public_path__ + "c5c0df49a0d72923b7f63bedf84506bc.webp";